import type { EmployeeContractsOut } from "@/pages/human-resources/time-management/endpoints/contracts/inout/EmployeeContractsOut.ts";
import axios from "axios";

export async function readEmployeesContracts(
  siteId: string,
  startDate: Date,
  endDate: Date,
): Promise<EmployeeContractsOut[]> {
  const { data } = await axios.get<EmployeeContractsOut[]>(
    `/api/hr/site/${siteId}/employee-contracts`,
    {
      params: {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
      },
    },
  );
  return data;
}
